import Head from "next/head";
import EnquiryHomePage from "@/components/EnquiryContainer/enquiry";
import { defaultEnquiryData } from "@/components/EnquiryContainer/enquiryData";
import homepageV2Data from "@/data/homepage-v2.json";

const EnquiryIndex = () => {
  const seoData = homepageV2Data?.seo;
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://bookmypoojaonline.com";
  const canonical = siteUrl;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": homepageV2Data.seo.structuredData.name,
    "url": siteUrl,
    "logo": `${siteUrl}${homepageV2Data.seo.structuredData.logo}`,
    "description": seoData?.description || homepageV2Data.seo.description,
    "sameAs": homepageV2Data.seo.structuredData.socialLinks,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": homepageV2Data.seo.structuredData.contactTelephone,
      "contactType": homepageV2Data.seo.structuredData.contactType
    }
  };

  return (
    <>
      <Head>
        <meta
          name="google-site-verification"
          content="Ttzt19k6OKEURdkJsmR_pHJbQPtd3fHL8uatwstkSAk"
        />
        <link rel="canonical" href={canonical} />
        <title>{seoData?.title || "BookMyPooja - Authentic Online Puja Services"}</title>
        <meta name="description" content={seoData?.description || "Book experienced pandit ji for all types of pujas at home or online."} />
        {seoData?.keywords && <meta name="keywords" content={seoData.keywords} />}
        <meta property="og:title" content={seoData?.title || "BookMyPooja"} />
        <meta property="og:description" content={seoData?.description || ""} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        {seoData?.ogImage && <meta property="og:image" content={seoData.ogImage} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
        
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>

      <main id="main-content" className="new-v2-theme min-h-screen bg-background pb-16 md:pb-0 font-sans">
        <EnquiryHomePage enquiryData={defaultEnquiryData} />
      </main>
    </>
  );
};

export default EnquiryIndex;
